import { observer } from 'mobx-react-lite';

import { Space } from '../../../app/entities';

import styles from './workspace-list.module.scss';

export const WorkspaceList = observer(() => {
  const spaces = Space.getAll();

  return (
    <div className={styles['list']}>
      {spaces.map((space) => (
        <div className={styles['item']}>
          <div className="column">
            <p>{space.name}</p>
            <p className="caption capitalize">{space.role}</p>
          </div>
        </div>
      ))}
    </div>
  );
});
